// This file provides a web-specific implementation for AppConfig.
// It returns a configuration object for the web environment, sourcing values from environment variables.

let config = null;

export const getConfig = () => {
  if (config) {
    return config;
  }

  const isDevelopment = process.env.NODE_ENV === 'development';

  // Use environment variables provided by the build process, with sensible defaults.
  config = {
    APP_ENV: process.env.NODE_ENV || 'development',
    CLIENT: process.env.APP_CLIENT || 'default',
    // Use the full backend URL from environment variables
    API_BASE_URL: process.env.API_BASE_URL,
    // NOVA_AI_BASE_URL: process.env.NOVA_AI_BASE_URL || 'https://nova-backend.lemonhill-8d1b12a9.eastus.azurecontainerapps.io',
    // On web, Nova AI requests use a relative path so they are proxied by
    // webpack-dev-server (/api → http://20.12.95.152) and avoid CORS.
    // On web, NOVA_AI_BASE_URL must point to the webpack dev-server origin so that
    // requests like /api/chat go through localhost:3000 and are intercepted by the
    // webpack proxy (/api → http://20.12.95.152) — bypassing CORS.
    // Setting a direct external IP here causes the browser to call it directly and get blocked.
    NOVA_AI_BASE_URL: process.env.NOVA_AI_BASE_URL || (isDevelopment ? 'http://localhost:3000' : ''),
    // Nova's streamed chat endpoint (/api/chat/stream) instead of the plain
    // one. Off unless an environment turns it on: the two endpoints both exist
    // on the backend, so this switches transport without a cutover, and any
    // failure falls back to the POST path mid-turn.
    NOVA_AI_STREAMING: String(process.env.NOVA_AI_STREAMING ?? '') === '1',
    // Dictate into the input box with the browser's own recogniser instead of
    // recording and uploading to AiDE. Off by default, and ignored where the
    // Web Speech API is missing (Firefox) — the hook reports that and the mic
    // falls back to the recording path.
    NOVA_AI_LIVE_TRANSCRIPTION: String(process.env.NOVA_AI_LIVE_TRANSCRIPTION ?? '') === '1',
    // Offer the "Hey Nova" switch in the chat header: the browser listens for
    // the wake word on the device and opens Nova's mic when it hears it. Off by
    // default; even where on, nothing listens until a technician switches it on.
    NOVA_AI_WAKE_WORD: String(process.env.NOVA_AI_WAKE_WORD ?? '') === '1',
    // Picovoice's AccessKey, for trying its Porcupine engine against
    // openWakeWord: with it set, a chip in the chat header switches between
    // the two. Unset, only openWakeWord is offered. A browser key is visible
    // in the page's code, as Picovoice's web SDK requires.
    NOVA_AI_PICOVOICE_ACCESS_KEY: process.env.NOVA_AI_PICOVOICE_ACCESS_KEY || '',
    ENABLE_LOGS: process.env.ENABLE_LOGS ? process.env.ENABLE_LOGS === 'true' : true,
  };

  return config;
};